import React, { FC } from 'react'
import { Dashboard } from '../../../common/components/Dashboard'

export const DoctorDashboard: FC<React.PropsWithChildren<unknown>> = () => {
  return <Dashboard />
}
